import { gql } from '@apollo/client';

export const GET_BOARD_CARD = gql`
  query GetBoardCard($where: CardUniqueFilterInput!) {
    card(where: $where) {
      title
      authors(first: 10) {
        author {
          id
        }
      }
      userId
      category
      publicationDate
      authors(first: 10) {
        id
      }
    }
  }
`;
